import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useI18n } from '../../contexts/I18nContext';

interface ThemeToggleProps {
 className?: string;
 showText?: boolean;
}

export function ThemeToggle({ className = '', showText = false }: ThemeToggleProps) {
 const { theme, toggleTheme } = useTheme();
 const { t } = useI18n();

 return (
<button 
  className={`flex items-center justify-center transition-colors rounded-full focus:outline-none focus:ring-2 focus:ring-violet-500/40 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-zinc-950 shrink-0 ${!showText ? 'w-8 h-8 md:w-9 md:h-9' : 'px-3 py-1.5 gap-2'} hover:bg-surface-elevated dark:hover:bg-zinc-700 text-text-muted ${className}`}
 onClick={toggleTheme} 
 title={t('landing', 'toggle_theme_title') || t('dashboard', 'toggle_theme')} 
 aria-label={t('landing', 'toggle_theme_aria') || t('dashboard', 'toggle_theme') || 'Toggle theme'}
 >
 {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
 {showText && <span className="text-[13px] font-semibold">{theme === 'dark' ? 'Chiaro' : 'Scuro'}</span>}
 </button>
 );
}
